/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class BuildingService {
        constructor(private $http: ng.IHttpService,
            private baseService: BaseService,
            private cookieService: CookiesService,
            private $q: ng.IQService,
            private textService: TextService,
            private organizationService: OrganizationService,
            private $rootScope: ng.IRootScopeService) {
            $rootScope.$on('onCompanySelect', () => {
                BuildingService.HasMultipleAssociations = null;
                BuildingService.tabs = null;
            });
        }

        public static tabs: TabModel[];
        private static HasMultipleAssociations: boolean;

        public indoorDataExists(filter: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/indoorexists', filter).then(j => { return j.data });
        }

        public outdoorDataExists(filter: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/outdoorexists', filter).then(j => { return j.data });
        }

        public landscapeDataExists(filter: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/landscapeexists', filter).then(j => { return j.data });
        }

        public mainDrawingsExist(filter: ModelFilterViewModel) {
            return this.baseService.post('maindrawing/{companyNumber}/any?isLandscape=false', filter).then(j => { return j.data });
        }

        public simMainDrawingsExist(filter: ModelFilterViewModel) {
            return this.baseService.post('maindrawing/{companyNumber}/any?isLandscape=true', filter).then(j => { return j.data });
        }

        public filterIndoorData(filter: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/indoorfilter', filter).then(j => { return j.data });
        }

        private base64ToArrayBuffer(data) {
            var binaryString = window.atob(data);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        }

        public exportIndoorDataToPdf(filter: ModelFilterViewModel) {
            return this.baseService.postArrayBuffer('buildingpart/{companyNumber}/indoor/pdf', filter).then(j => { return j.data });
        }

        public exportOutdoorDataToPdf(filter: ModelFilterViewModel) {
            return this.baseService.postArrayBuffer('buildingpart/{companyNumber}/outdoor/pdf', filter).then(j => { return j.data });
        }

        public exportLandscapeDataToPdf(filter: ModelFilterViewModel) {
            return this.baseService.postArrayBuffer('buildingpart/{companyNumber}/landscape/pdf', filter).then(j => { return j.data });
        }

        public filterOutdoorData(filter: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/outdoorfilter', filter).then(j => { return j.data });
        }

        public filterSimData(filter: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/landscapefilter', filter).then(j => { return j.data });
        }

        public getRoomTypes(associationNumber: string) {
            return this.baseService.get('roomtype/{companyNumber}/' + associationNumber + '/list').then(f => { return f.data });
        }

        public getSelectors(filters: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/selectors', filters).then(f => { return f.data });
        }

        public getSurfaceMaterials(filters: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/surfacematerials', filters).then(f => { return f.data });
        }

        public getTypes(filters: ModelFilterViewModel) {
            return this.baseService.post('buildingpart/{companyNumber}/types', filters).then(f => { return f.data });
        }

        public getFilters() {
            var data = <ModelFilterViewModel>angular.fromJson(this.cookieService.readCookie("modelFilter"));
            var filter = new ModelFilterViewModel();
            if (data != null) {
                filter.copyFrom(data);
                if (filter.localizer.any()) {
                    filter.localizer.values = filter.localizer.values.map(l => decodeURIComponent(l));
                }
            }
            
            return filter;
        }

        public saveFilters(filter: ModelFilterViewModel) {
            var newCookie = new ModelFilterViewModel();
            newCookie.copyFrom(filter);
            if (newCookie.localizer != null && newCookie.localizer.values != null && newCookie.localizer.values.length > 0) {
                newCookie.localizer.values = newCookie.localizer.values.map(l => encodeURIComponent(l));
            }
            this.cookieService.createCookie("modelFilter", JSON.stringify(newCookie), 720);
        }

        public getPhotoUploadFilters() {
            var data = <ModelFilterViewModel>angular.fromJson(this.cookieService.readCookie("photoUploadFilter"));
            var filter = new ModelFilterViewModel();
            if (data != null) {
                filter.copyFrom(data);
                if (filter.localizer.any()) {
                    filter.localizer.values = filter.localizer.values.map(l => decodeURIComponent(l));
                }
            }
            
            return filter;
        }

        public isTabSetup() {
            return BuildingService.tabs != null;
        }

        public setTabs(tabs: TabModel[]) {
            if (tabs != null) {
                BuildingService.tabs = tabs;
            }
        }

        public hasMultipleAssociations(): ng.IPromise<boolean> {
            var def = this.$q.defer();
            if (BuildingService.HasMultipleAssociations == null) {
                this.organizationService.list().then(b => {
                    BuildingService.HasMultipleAssociations = b.length > 1;
                    def.resolve(BuildingService.HasMultipleAssociations);
                }, () => def.reject());
            }
            else {
                def.resolve(BuildingService.HasMultipleAssociations);
            }
            return <ng.IPromise<boolean>>def.promise;
        };

        public getTabs(features: CompanyFeatureList) {
            if (BuildingService.tabs == null) {
                BuildingService.tabs = [
                    {
                        name: 'floorplan',
                        url: '#!/building/floorplan',
                        text: this.textService.translate('ModelList_Floorplans'),
                        isShown: true,
                        isEnabled: false,
                        cssClass: 'indoor'
                    },
                    {
                        name: 'indoor',
                        url: '#!/building/indoor',
                        text: this.textService.translate('ModelList_IndoorSurface'),
                        isShown: features.includeIndoorData(),
                        isEnabled: false,
                        cssClass: 'indoor'
                    },
                    {
                        name: 'outdoor',
                        url: '#!/building/outdoor',
                        text: this.textService.translate('ModelList_OutdoorSurface'),
                        isShown: features.includeOutdoorData(),
                        isEnabled: false,
                        cssClass: 'outdoor'
                    },
                    {
                        name: 'maindrawing',
                        url: '#!/building/maindrawing',
                        text: this.textService.translate('ModelList_MainImages'),
                        isShown: features.includeOutdoorData(),
                        isEnabled: false,
                        cssClass: 'outdoor'
                    },
                    {
                        name: 'sim',
                        url: '#!/building/sim',
                        text: this.textService.translate('ModelList_SimSurface'),
                        isShown: features.includeSimData(),
                        isEnabled: false,
                        cssClass: 'sim'
                    },
                    {
                        name: 'simmaindrawing',
                        url: '#!/building/simmaindrawing',
                        text: this.textService.translate('ModelList_MainImagesSim'),
                        isShown: features.includeSimData(),
                        isEnabled: false,
                        cssClass: 'sim'
                    },
                    {
                        name: 'scannedimage',
                        url: '#!/building/scannedimage',
                        text: this.textService.translate('ModelList_ScannedImages'),
                        isShown: features.includeScannedImages(),
                        isEnabled: false,
                        cssClass: ''
                    }
                    ,
                    {
                        name: 'universalstorage',
                        url: '#!/building/universalstorage',
                        text: this.textService.translate('ModelList_MyDrawings'),
                        isShown: features.includeUniversalStorage(),
                        isEnabled: false,
                        cssClass: ''
                    }
                ];
            }
            return BuildingService.tabs;
        }
    }

    BuildingService.$inject = ['$http', 'BaseService', 'CookiesService', '$q', 'TextService', 'OrganizationService', '$rootScope'];
    angular
        .module('eseebase')
        .service('BuildingService', BuildingService);
}